import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ProductsTable() {
  const [products, setProducts] = useState([]);
  const [historyDate, setHistoryDate] = useState("");
  const [history, setHistory] = useState([]);

  const fetchTodayStock = async () => {
    const res = await axios.get(`${apiUrl}/api/stock-check/today`);
    setProducts(res.data);
  };

  useEffect(() => {
    fetchTodayStock();
  }, []);

  const markPresent = async (id) => {
    const user = localStorage.getItem("user");
    await axios.post(`${apiUrl}/api/stock-check/${id}`, {
      checkedBy: user,
    });

    fetchTodayStock();
  };

  const fetchHistory = async () => {
    if (!historyDate) return;

    const res = await axios.get(
      `${apiUrl}/api/stock-check/history?date=${historyDate}`
    );
    setHistory(res.data);
  };

  useEffect(() => {
    fetchHistory();
  }, [historyDate]);

  return (
    <div className="max-w-7xl m-auto p-4 mb-40">
      <h2 className="text-xl mb-3">Night Stock Check</h2>

      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th></th>
            <th>Order #</th>
            <th>Device</th>
            <th>Buyer</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.ID} className={!p.checked ? "bg-yellow-100" : ""}>
              <td className="text-center">
                <input
                  type="checkbox"
                  checked={!!p.checked}
                  disabled={!!p.checked}
                  onChange={() => markPresent(p.ID)}
                />
              </td>

              <td>{p.OrderNumber}</td>
              <td>
                {p.Brand} {p.Model} ({p.Ram}/{p.Storage})
              </td>
              <td>{p.buyer || "-"}</td>
              <td>{p.ourStat}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===== HISTORY SECTION ===== */}
      <h2 className="text-xl mb-3 mt-5">Stock Check History</h2>

      <div className="flex gap-3 mb-4">
        <input
          type="date"
          value={historyDate}
          onChange={(e) => setHistoryDate(e.target.value)}
          className="border p-1"
        />
      </div>

      {history.length > 0 && (
        <table className="min-w-full border">
          <thead>
            <tr>
              <th className="bg-gray-200">Order #</th>
              <th className="bg-gray-300">Device</th>
              <th className="bg-gray-200">Checked At</th>
              <th className="bg-gray-300">Checked By</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h) => (
              <tr key={`${h.ID}-${h.checked_at}`}>
                <td className="bg-gray-100">{h.OrderNumber}</td>
                <td className="bg-gray-200">
                  {h.Brand} {h.Model} ({h.Ram}/{h.Storage})
                </td>
                <td className="bg-gray-100">{new Date(h.checked_at).toLocaleString()}</td>
                <td className="bg-gray-200">{h.checked_by}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {historyDate && history.length === 0 && (
        <p className="text-gray-500">No items were checked on this date.</p>
      )}
    </div>
  );
}
